<template>
  <div v-loading="dataLoading">
    <rhcn-drawer
      :title="id ? 'message.alert.editRdrEnrollment' : 'message.alert.addRdrEnrollment'"
      @on-close="onClose">
      <div class="enrollment-form">
        <validation-component
          ref="enrollmentForm"
          :validation-condition="enrollmentCondition"
        >
        </validation-component>
        <div class="margin-top-25 margin-bottom-25">
          <el-button
            style="width: 100%"
            type="primary"
            :loading="requesting"
            @click="onSubmit"
            >{{getSubmitText()}}</el-button
          >
        </div>
      </div>
    </rhcn-drawer>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

import RhcnDrawer from '@/components/drawer/index.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips.js';
import { REQUIRED } from '@/components/validation/tool/validator';
import ValidationComponent from '@/components/validation/validation.vue';
import GlobalData from '@/utils/global/index';
import {
  getEnantiomericValue, initSelectedData,
} from '@/utils/tools/constant';
import { queryRDREnrollmentDetail, updateRDREnrollmentInfo, addRDREnrollmentInfo } from '@/views/risk/api/rdr';

export default {
  components: {
    RhcnDrawer,
    ValidationComponent,
  },
  data() {
    return {
      id: this.$route.query.id,
      requesting: false,
      dataLoading: false,
      enrollmentCondition: [{
        key: 'preDisputeService',
        name: 'message.alert.preDisputeService',
        type: 'select',
        defValue: '',
        isShowStar: true,
        rule: [REQUIRED],
        placeholder: 'message.alert.preDisputeServiceInputTips',
      }, {
        key: 'bin',
        name: 'message.alert.BIN',
        type: 'input',
        defValue: '',
        isShowStar: true,
        rule: [REQUIRED],
        placeholder: 'message.alert.BINInputTips2',
      }, {
        key: 'caid',
        name: 'message.alert.CAID',
        type: 'input',
        defValue: '',
        isShowStar: true,
        rule: [REQUIRED],
        placeholder: 'message.alert.CAIDInputTips',
      }, {
        key: 'mcc',
        name: 'message.alert.MCC',
        type: 'input',
        defValue: '',
        isShowStar: true,
        rule: [REQUIRED],
        placeholder: 'message.alert.MCCInputTips2',
      }, {
        key: 'dba',
        name: 'message.alert.DBA',
        type: 'input',
        defValue: '',
        isShowStar: true,
        rule: [REQUIRED],
        placeholder: 'message.alert.DBAInputTips',
      }, {
        key: 'resellerSubMerchantId',
        name: 'message.alert.resellerSubMerchantId',
        type: 'input',
        defValue: '',
        rule: [],
        placeholder: 'message.alert.resellerSubMerchantIdInputTips2',
      }, {
        key: 'arn',
        name: 'message.alert.arn',
        type: 'input',
        defValue: '',
        rule: [],
        placeholder: 'message.alert.ARNInputTips',
      }, {
        key: 'notes',
        name: 'message.alert.note',
        type: 'textarea',
        defValue: '',
        rule: [],
      }],
      enrollmentStatus: '',
    };
  },
  computed: {
    ...mapGetters([
      'app',
    ]),
  },
  mounted() {
    this.initMethod();
  },
  methods: {
    async initMethod() {
      this.dataLoading = true;
      try {
        const dict = await GlobalData.getDictList(['RDR_ACW_PRE_DISPUTE_SERVICE']);
        this.$refs.enrollmentForm.setValidationSelectOptions('preDisputeService', initSelectedData(dict.RDR_ACW_PRE_DISPUTE_SERVICE, 'description', 'value', false));
        if (this.id) {
          const res = await queryRDREnrollmentDetail(this.id);
          this.$refs.enrollmentForm.assignmentFormValue({ ...res });
          this.enrollmentStatus = res.enrollmentStatus;
          this.$refs.enrollmentForm.setItemDisabled(
            'preDisputeService',
            ['SUBMITTED_AND_PENDING_ENROLLMENT', 'ENROLLED', 'SUBMITTED_AND_PENDING_DISENROLLMENT', 'DISENROLLED'].includes(this.enrollmentStatus),
          );
          this.$refs.enrollmentForm.setItemDisabled(
            'bin',
            ['SUBMITTED_AND_PENDING_ENROLLMENT', 'ENROLLED', 'SUBMITTED_AND_PENDING_DISENROLLMENT', 'DISENROLLED'].includes(this.enrollmentStatus),
          );
          this.$refs.enrollmentForm.setItemDisabled(
            'caid',
            ['SUBMITTED_AND_PENDING_ENROLLMENT', 'ENROLLED', 'SUBMITTED_AND_PENDING_DISENROLLMENT', 'DISENROLLED'].includes(this.enrollmentStatus),
          );
          this.$refs.enrollmentForm.setItemDisabled(
            'mcc',
            ['SUBMITTED_AND_PENDING_ENROLLMENT', 'ENROLLED', 'SUBMITTED_AND_PENDING_DISENROLLMENT', 'DISENROLLED'].includes(this.enrollmentStatus),
          );
          this.$refs.enrollmentForm.setItemDisabled(
            'dba',
            ['SUBMITTED_AND_PENDING_ENROLLMENT', 'ENROLLED', 'SUBMITTED_AND_PENDING_DISENROLLMENT', 'DISENROLLED'].includes(this.enrollmentStatus),
          );
          this.$refs.enrollmentForm.setItemDisabled(
            'resellerSubMerchantId',
            ['SUBMITTED_AND_PENDING_ENROLLMENT', 'ENROLLED', 'SUBMITTED_AND_PENDING_DISENROLLMENT', 'DISENROLLED'].includes(this.enrollmentStatus),
          );
          this.$refs.enrollmentForm.setItemDisabled(
            'notes',
            ['SUBMITTED_AND_PENDING_ENROLLMENT', 'SUBMITTED_AND_PENDING_DISENROLLMENT'].includes(this.enrollmentStatus),
          );
        }
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    getSubmitText() {
      let text = 'message.alert.submitEnrollment';
      if (this.enrollmentStatus === 'SUBMITTED_AND_PENDING_ENROLLMENT') { // 待开通
        text = 'message.alert.withdrawEnrollment';
      } else if (this.enrollmentStatus === 'ENROLLED') { // 已开通
        text = 'message.alert.submitDisenrollment';
      } else if (this.enrollmentStatus === 'SUBMITTED_AND_PENDING_DISENROLLMENT') { // 待关闭
        text = 'message.alert.withdrawDisenrollment';
      }
      return this.$t(text);
    },
    onClose() {
      this.$router.go(-1);
    },
    onSubmit() {
      let status = 'SUBMITTED_AND_PENDING_ENROLLMENT'; // 待开通
      let enrollmentEvent = 'MERCHANT_SUBMIT'; // 商户提交
      switch (this.enrollmentStatus) {
      case 'SUBMITTED_AND_PENDING_ENROLLMENT': // 待开通
        status = 'PENDING_SUBMISSION';
        enrollmentEvent = 'MERCHANT_WITHDRAW'; // 商户撤回
        break;
      case 'ENROLLED': // 已开通
        status = 'SUBMITTED_AND_PENDING_DISENROLLMENT'; // 待关闭
        break;
      case 'SUBMITTED_AND_PENDING_DISENROLLMENT': // 待关闭
        status = 'ENROLLED'; // 已开通
        enrollmentEvent = 'MERCHANT_WITHDRAW'; // 商户撤回
        break;
      }

      this.$refs.enrollmentForm.toFormValid(async (params) => {
        const data = {
          ...params,
          enrollmentStatus: this.enrollmentStatus,
          enrollmentEvent,
        };

        if (this.id) {
          data.id = this.id;
          await updateRDREnrollmentInfo(data);
        } else {
          await addRDREnrollmentInfo(data);
        }
        ShowSuccessMessage(this.$t('message.submitSuccessfulTip'));
        setTimeout(() => {
          this.onClose();
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.enrollment-form {
  width: 450px;
  margin: 36px auto 0;
}
</style>
